import { render } from "./couponsShow.vue?vue&type=template&id=303badb9&scoped=true"
import script from "./couponsShow.vue?vue&type=script&lang=js"
export * from "./couponsShow.vue?vue&type=script&lang=js"

import "./couponsShow.vue?vue&type=style&index=0&id=303badb9&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-303badb9"]])

export default __exports__